// extracted by mini-css-extract-plugin
export default {"inputGroup":"input-group_inputGroup__jTzsb","labelPart":"input-group_labelPart__SSRGB","inputPart":"input-group_inputPart__GDyVT"};